import { useEffect, useReducer } from "react";
import { useState } from "react";
import CustomTitle from "../../components/CustomMiscellaneous/CustomTitle";
import { genericGet } from "../../services/api.service";
import { ListagemPecasParaOperacao } from "./ListagemPecasParaOperacao";
import { SeleccaoObraEntregaOperacao } from "./SeleccaoObraEntregaOperacao";
import QRCodePicker from "./QRCodePicker";
import { FactoryFloorContext, ISelectionValues } from "../../contexts/FactoryFloorContext";




export default function FactoryFloorView() {

    const [pecasParaEntregaData, setPecasParaEntregaData] = useState([]);

    const [externalPecasFilter, setExternalPecasFilter] = useState<any[]>([]);

    const [scannerConnected, setScannerConnected] = useState(false);

 
    const [selectionValues, setSelectionValues] = useReducer((state: ISelectionValues, action: any) => {
        if(Object.keys(action).length == 0) return {};
        return { ...state, ...action }
    }, { obra: null, entrega: null, operacao: null, pecaEntrega: null })

    const requestReady = () => selectionValues.obra && selectionValues.entrega && selectionValues.operacao;


    useEffect(() => {
        if (requestReady()) {
            genericGet(`/obras/${selectionValues.obra?.id}/entregas/${selectionValues.entrega?.id}/operacoes/${selectionValues.operacao}`)
                .then(d => {
                    setPecasParaEntregaData(d);
                })
        } 
    }, [selectionValues])


    useEffect(() => {
        if (!scannerConnected) {
            setExternalPecasFilter([]);
        } else {
            setSelectionValues({});
        }
    }, [scannerConnected])

    useEffect(()=> {
        if(scannerConnected && pecasParaEntregaData.length > 0) {            
            setExternalPecasFilter([selectionValues.pecaEntrega.peca]);
        }
    },[pecasParaEntregaData])


    return (<>
        <CustomTitle text={'Processar operações para entrega'} />

        <FactoryFloorContext.Provider value={{ selectionValues, setSelectionValues }}>
            
            <QRCodePicker
                setScannerConnected={setScannerConnected}
            />

            <SeleccaoObraEntregaOperacao
                scannerConnected={scannerConnected}
            />

            <ListagemPecasParaOperacao
                pecasParaEntrega={pecasParaEntregaData}
                setPecasParaEntrega={setPecasParaEntregaData}
                externalPecasFilter={externalPecasFilter}
            />
        </FactoryFloorContext.Provider>

    </>)


}